<template>
  <div
    class="overflow-hidden border-b border-b-line transition-all duration-300"
    :class="collapseOpened ? 'max-h-[296px]' : 'max-h-[56px]'"
  >
    <div
      class="
        flex
        justify-between
        items-center
        py-4
        bg-primary
        px-4
        cursor-pointer
      "
      @click="collapseOpened = !collapseOpened"
    >
      <div class="font-bold">{{ title }}</div>
      <div class="font-bold">
        <img
          src="/static/images/icons/arrow-down.svg"
          class=" w-4 h-4 transition-all duration-300"
          :class="collapseOpened ? 'rotate-[-90deg]' : 'rotate-90'"
          alt="menu-arrow"
        />
      </div>
    </div>
    <div class="w-full"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      collapseOpened: false,
    };
  },
};
</script>